import { IonAlert } from '@ionic/react';
import React, { useContext, useState } from 'react';
import { MessageContext } from '../contexts/MessageContext';

export function useStoreSwitch(onSwitch: () => void) {
  const { storeAccess, listaItemProdutos, clearActiveStore } = useContext(MessageContext);
  const [confirm, setConfirm] = useState(false);
  const canSwitchStore = storeAccess.accessMode === 'marketplace';
  const switchStore = () => {
    if (!canSwitchStore) return;
    clearActiveStore();
    setConfirm(false);
    onSwitch();
  };
  const requestStoreSwitch = () => {
    if (!canSwitchStore) return;
    if (listaItemProdutos?.length) setConfirm(true);
    else switchStore();
  };
  const storeSwitchAlert = <IonAlert isOpen={confirm} onDidDismiss={() => setConfirm(false)}
    header="Trocar de loja?" message="Os itens do carrinho serão removidos. Seu endereço será mantido."
    buttons={[{ text: 'Cancelar', role: 'cancel' }, { text: 'Trocar loja', role: 'confirm', handler: switchStore }]} />;
  return { canSwitchStore, requestStoreSwitch, storeSwitchAlert };
}
